import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { APP_URL, SessionStorageKey } from '@constants/index'
import { getToken } from '@utils/authenticate'
import { setSessionStorage } from '@utils/storage'

export function RequireAuth() {
  const location = useLocation()
  const token = getToken()

  if (!token) {
    // Stash any query params (e.g. ?oa=matching) so we can return after auth.
    if (location.search) {
      setSessionStorage(SessionStorageKey.RETURN_URL, `${location.pathname}${location.search}`)
    }
    return <Navigate to={APP_URL.LOGIN} replace />
  }

  return <Outlet />
}
